const WarningIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 16 16"  width={props.width ?? 16} height={props.height ?? 16}>
        <path fill={props.color}
            d="M8.2111 2C7.87682 2 7.54268 2.15578 7.35554 2.4672L2.13408 11.1538C1.74932 11.7937 2.2416 12.6667 2.98848 12.6667H13.4326C14.1792 12.6667 14.6729 11.7937 14.2881 11.1538L9.06666 2.4672C8.87953 2.15578 8.54539 2 8.2111 2ZM8.2111 3.3471L13.0998 11.4795H3.32236L8.2111 3.3471ZM7.61754 5.54396V8.51176H8.80466V5.54396H7.61754ZM7.61754 9.69887V10.886H8.80466V9.69887H7.61754Z" />
    </svg>
);

export default WarningIcon;